import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GiftCardService } from 'app/landing-pages/gift-card/gift-card.service';
import {  } from 'events';

@Component({
  selector: 'zest-tnc-card',
  templateUrl: './tnc-card.component.html',
  styleUrls: ['./tnc-card.component.scss']
})
export class TncCardComponent implements OnInit {

  @Input() merchantName: string;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  tncs: any;

  constructor(
    private giftCardService: GiftCardService
  ) { }

  ngOnInit() {
    if (this.merchantName) {
      this.giftCardService.getTnCs().subscribe(
        response => {
          if (Object.keys(response['data']).indexOf(this.merchantName.toLowerCase()) > -1) {
            this.tncs = response['data'][this.merchantName.toLowerCase()][0];
          } else {
            this.tncs = response['data']['default'][0];
            this.tncs = JSON.parse(this.replaceAll(JSON.stringify(this.tncs), '{{brand}}', this.merchantName));
          }
        }
      );
    }
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  closeTnC() {
    this.close.emit(true);
  }
}
